import { pathJoin } from 'src/reducers/routing/utils'

export const createWeightControlRouteMap = (prefix: string) => ({
  'need-approval': pathJoin(prefix)('need-approval').chain,
  'awaiting-completion': pathJoin(prefix)('awaiting-completion').chain,
  completed: pathJoin(prefix)('completed').chain,
})
